// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"56f46472","833":"b19a6c52"}[chunkId] + ".chunk.js";
};